import { Card, Tabs, Badge } from 'antd';
import { BellOutlined, HistoryOutlined } from '@ant-design/icons';
import type { TabsProps } from 'antd';

interface AlertNotificationTabsProps {
  announcementContent: React.ReactNode;
  activityContent: React.ReactNode;
  unreadCount?: number;
  loading?: boolean;
}

export function AlertNotificationTabs({
  announcementContent,
  activityContent,
  unreadCount = 0,
  loading: _loading,
}: AlertNotificationTabsProps) {
  const items: TabsProps['items'] = [
    {
      key: 'announcements',
      label: (
        <span>
          <BellOutlined />
          アナウンス
          {unreadCount > 0 && (
            <Badge
              count={unreadCount}
              style={{ marginLeft: 8 }}
              overflowCount={99}
            />
          )}
        </span>
      ),
      children: announcementContent,
    },
    {
      key: 'activities',
      label: (
        <span>
          <HistoryOutlined />
          最近の活動
        </span>
      ),
      children: activityContent,
    },
  ];

  return (
    <Card styles={{ body: { padding: 0 } }}>
      <Tabs
        defaultActiveKey="announcements"
        items={items}
        style={{ padding: '0 24px' }}
        tabBarStyle={{ marginBottom: 0 }}
      />
    </Card>
  );
}
